export default class UserImageProvider {
	userImages: { [key: string]: string } = {}

	public setValues (userImages: { [key: string]: string }) {
		this.userImages = userImages
	}

	getImageUrl (userId: string): string | null {
		return this.userImages[userId] || null
	}
}
